import { endpoint } from '../decorators/endpoint.decorator';
import { BaseViewModel } from './base-view-model';

@endpoint('Category')
export class CategoryViewModel extends BaseViewModel {
  public Name = '';
  public Description = '';
}
